'use strict';

require('./index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/mention/style/index.tsx
 ** module id = 357
 ** module chunks = 0
 **/